// formik components
import { Formik, Form } from "formik";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import toast from "react-hot-toast";
// components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

// example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// BillDetail layout schemas for form and form feilds
import BillInfo from "./info";
import form from "./schemas/form";
import validation from "./schemas/validations";
import initialValues from "./schemas/initialValues";
import { BillService } from "services/billService";

function BillInDetail() {
  const { formId, formField } = form;
  const { id } = useParams();
  const location = useLocation();
  const containEdit = location.pathname?.includes("/edit");
  const navigation = useNavigate();
  const [getData, setGetData] = useState({});
  const [data, setData] = useState({});

  useEffect(() => {
    if (!id) return;
    (async () => {
      const { data } = await BillService.getById(id);
      setGetData(data);
    })();
  }, [id]);

  const onChangeValue = (type, value) => {
    setData((prev) => ({ ...prev, [type]: value }));
  };

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  const handleBack = () => navigation(-1);

  const handleUpdate = async (payload, actions) => {
    try {
      await BillService.update(id, payload);
      actions.setSubmitting(false);
      toast.success(`Cập nhật hóa đơn thành công`);
      setTimeout(() => {
        navigation(-1);
      }, 1500);
    } catch (error) {
      actions.setSubmitting(false);
      toast.error(`Cập nhật hóa đơn thất bại`);
      console.log("🍕 ~ error:", error);
    }
  };
  const handleCreate = async (payload, actions) => {
    console.log(payload);
    try {
      await BillService.create(payload);
      actions.setSubmitting(false);
      toast.success(`Tạo hóa đơn thành công`);
      setTimeout(() => {
        navigation(-1);
      }, 1500);
    } catch (error) {
      actions.setSubmitting(false);
      toast.error(`Tạo hóa đơn thất bại`);
      console.log("🍕 ~ error:", error);
    }
  };

  const checkValidate = async (payload, actions) => {
    let err = false;
    if (!payload.invoiceSymbol) {
      err = true;
      toast.error(`Vui lòng nhập mã hóa đơn`);
      actions.setSubmitting(false);
    } else if (!payload.number) {
      err = true;
      toast.error(`Vui lòng nhập số hóa đơn`);
      actions.setSubmitting(false);
    } else if (!payload.payments) {
      err = true;
      toast.error(`Vui lòng chọn hình thức thanh toán`);
      actions.setSubmitting(false);
    } else if (!payload.currency) {
      err = true;
      toast.error(`Vui lòng chọn đồng tiền thanh toán`);
      actions.setSubmitting(false);
    } else if (!payload.day) {
      err = true;
      toast.error(`Vui lòng chọn ngày xuất hóa đơn`);
      actions.setSubmitting(false);
    } else if (!payload.sellerName) {
      err = true;
      toast.error(`Vui lòng nhập tên người bán`);
      actions.setSubmitting(false);
    } else if (!payload.sellerPhone) {
      err = true;
      console.log(payload.sellerPhone);
      toast.error(`Vui lòng nhập số điện thoại người bán`);
      actions.setSubmitting(false);
    } else if (
      payload.sellerPhone &&
      (payload.sellerPhone.split("").length < 10 || payload.sellerPhone.split("").length > 11)
    ) {
      err = true;
      toast.error(`Số điện thoại người bán không hợp lệ (Việt Nam)`);
      actions.setSubmitting(false);
    } else if (
      payload.sellerPhone &&
      payload.sellerPhone.split("").length === 10 &&
      !/^(02[2-9]|03[2-9]|07[0-9]|08[1-9]|09[0-9]|01[2|6|8|9])\d{7}$/.test(payload.sellerPhone)
    ) {
      err = true;
      toast.error(`Số điện thoại người bán không hợp lệ (Việt Nam)`);
      actions.setSubmitting(false);
    } else if (
      payload.sellerPhone &&
      payload.sellerPhone.split("").length === 11 &&
      !/^(02[2-9]|03[2-9]|07[0-9]|08[1-9]|09[0-9]|01[2|6|8|9])\d{8}$/.test(payload.sellerPhone)
    ) {
      err = true;
      toast.error(`Số điện thoại người bán không hợp lệ (Việt Nam)`);
      actions.setSubmitting(false);
    } else if (!payload.sellerAddress) {
      err = true;
      toast.error(`Vui lòng nhập địa chỉ người bán`);
      actions.setSubmitting(false);
    } else if (payload.payments === "transfer" && !payload.sellerBankAccount) {
      err = true;
      toast.error(`Vui lòng nhập số tài khoản người bán`);
      actions.setSubmitting(false);
    } else if (payload.payments === "transfer" && !payload.buyerBankAccount) {
      err = true;
      toast.error(`Vui lòng nhập số tài khoản người mua`);
      actions.setSubmitting(false);
    } else if (!payload.buyerName) {
      err = true;
      toast.error(`Vui lòng nhập tên người mua`);
      actions.setSubmitting(false);
    } else if (!payload.buyerAddress) {
      err = true;
      toast.error(`Vui lòng nhập địa chỉ người mua`);
      actions.setSubmitting(false);
    } else if (
      payload.totalPaymentTax &&
      payload.payments === "cash" &&
      payload.totalPaymentTax > 20000000
    ) {
      err = true;
      toast.error(`Giá trị hóa đơn trên 20 triệu vui lòng đổi hình thức thanh toán chuyển khoản`);
      actions.setSubmitting(false);
    } else if (payload.products.length > 0) {
      let index = 1;
      for await (const item of payload.products) {
        if (!item.name) {
          err = true;
          toast.error(`Vui lòng nhập tên sản phẩm số ${index}`);
        } else if (!item.unit) {
          err = true;
          toast.error(`Vui lòng nhập đơn vị tính sản phẩm số ${index}`);
        } else if (!item.price) {
          err = true;
          toast.error(`Vui lòng nhập số tiền sản phẩm số ${index}`);
        } else if (!item.quantity) {
          err = true;
          toast.error(`Vui lòng nhập số lượng sản phẩm số ${index}`);
        } else {
        }
        index++;
      }
    } else {
    }

    return err;
  };

  const submitForm = async (values, actions) => {
    const payload = {
      invoiceSymbol: values.invoiceSymbol,
      number: values.number,
      buyerAddress: values.buyerAddress,
      buyerBankAccount: values.buyerBankAccount,
      buyerName: values.buyerName,
      buyerTaxCode: values.buyerTaxCode,
      currency: values.currency,
      day: values.day,
      payments: values.payments,
      products: values.products,
      sellerAddress: values.sellerAddress,
      sellerBankAccount: values.sellerBankAccount,
      sellerName: values.sellerName,
      sellerPhone: values.sellerPhone,
      sellerTaxCode: values.sellerTaxCode,
      totalPaymentTax: values.totalPaymentTax,
      type: "bill in",
    };
    const validate = await checkValidate(payload, actions);
    if (validate) return;
    if (id) {
      await handleUpdate(payload, actions);
    } else {
      console.log("create");
      await handleCreate(payload, actions);
    }
  };
  const handleSubmit = async (values, actions) => {
    await submitForm({ ...values, ...data }, actions);
    actions.setTouched({});
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3} mb={20}>
        <Grid container justifyContent="center" sx={{ height: "100%" }}>
          <Grid item xs={12} lg={12}>
            <Formik
              initialValues={initialValues}
              // validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <SoftBox p={2}>
                      <SoftBox>
                        <BillInfo
                          formData={{
                            values,
                            touched,
                            formField,
                            errors,
                            getData,
                            onChangeValue,
                            setFieldValue,
                          }}
                        />
                        <SoftBox mt={10} width="100%" display="flex" justifyContent="space-between">
                          <SoftButton variant="gradient" color="light" onClick={handleBack}>
                            Trở về
                          </SoftButton>
                          {!id && (
                            <SoftBox display="flex" gap={3}>
                              <SoftButton
                                disabled={isSubmitting}
                                type="submit"
                                variant="gradient"
                                color="dark"
                              >
                                Tạo
                              </SoftButton>
                            </SoftBox>
                          )}
                          {id && containEdit && (
                            <SoftBox display="flex" gap={3}>
                              <SoftButton
                                disabled={isSubmitting}
                                type="submit"
                                variant="gradient"
                                color="dark"
                              >
                                Lưu
                              </SoftButton>
                            </SoftBox>
                          )}
                        </SoftBox>
                      </SoftBox>
                    </SoftBox>
                  </Card>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
}

export default BillInDetail;
